import React, { useState } from 'react'
import { Switch } from '@mui/material'
import { ArrowDropDown, Sort, Photo } from '@mui/icons-material'
import axios from 'axios'

const ProductForm = () => {

  const [form, setForm] = useState(
    {
      name:'',
      price:'',
      description:'',
      deliver:'',
      condition:'',
      material:'',
      stock:'',
      rating: {
        "rate": 4,
        "count": 120
      },
    })
    const handleChange = (e) => {
      const { name, value } = e.target
      setForm({...form, [name]:value} )
    }
    const [ formError, setFormError ] = useState(false)


  function handlePayment (total){
    if(form.name === '' || form.email === '' || form.address === '' || form.city === '' || form.state === '' || form.zip_code === '' ){
      setFormError(true)
    }else{
        // setProducts((prev) => [...prev, form])
      setForm(
        {
            name:'',
            price:'',
            description:'',
            deliver:'',
            condition:'',
            material:'',
            stock:'',
            rating: {
              "rate": 4,
              "count": 120
            },
          }
      )
      alert('New Product added')
      
    }
  }
  const [ sizeDrop, setSizeDrop ] = useState(false)
  const [ currentSize, setCurrentSize ] = useState('30 - 35')
  function setSize(size){
    setCurrentSize(size)
    setSizeDrop(false)
  }
  const [img1, setImg1] = useState(null)
  const [preview1, setPreview1] = useState(null)

  const [img2, setImg2] = useState(null)
  const [preview2, setPreview2] = useState(null)

  const [img3, setImg3] = useState(null)
  const [preview3, setPreview3] = useState(null)

  const [img4, setImg4] = useState(null)
  const [preview4, setPreview4] = useState(null)

  function handleFileChange(e, imgId){
    if(imgId === 'img1'){
      const file = e.target.files[0]
      if(file){
        setImg1(file)
        setPreview1(URL.createObjectURL(file))
      }
    }


    if(imgId === 'img2'){
      const file = e.target.files[0]
      if(file){
        setImg2(file)
        setPreview2(URL.createObjectURL(file))
      }
    }

    if(imgId === 'img3'){
      const file = e.target.files[0]
      if(file){
        setImg3(file)
        setPreview3(URL.createObjectURL(file))
      }
    }

    if(imgId === 'img4'){
      const file = e.target.files[0]
      if(file){
        setImg4(file)
        setPreview4(URL.createObjectURL(file))
      }
    }

  }
  const [formPreview, setFormPreview] = useState(false)
  return (
    <div className='flex flex-col h-[100vh] justify-center items-center productForm p-4'>
        {formPreview === false ? <form className=' shadow-lg md:w-[50vw] bg-white flex flex-col p-2 space-y-2'>
        
    <div className='flex flex-col justify-center items-center p-4'>
      <p className='font-bold text-2xl text-center text-purple-700'>Add A New Product</p>
      <p className='font-semibold p-2 text-sm text-gray-600'>Admin product form</p>
    </div>
    <div className='grid grid-cols-2 '> 
    <label className='flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>Name</p>
    <input value={form.name} onChange={handleChange} style={{ border:`solid ${formError && form.name === '' ? '2px' : '1px'} ${formError && form.name === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.name === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='name' type='text' placeholder='Name'/>
    </label>
    <label className='flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>Price</p>
    <input value={form.price} onChange={handleChange} style={{ border:`solid ${formError && form.price === '' ? '2px' : '1px'} ${formError && form.price === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.price === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='price' type='text' placeholder='Price'/>
    </label>
    
    <label className='flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>Delivery status</p>
    <div className='flex md:space-x-4 p-1'>
    <p className='text-gray-500 font-semibold p-2'>No</p>  
      <Switch/>
    <p className='text-purple-700 font-semibold p-2'>Yes</p>
    </div>
    {/* <input value={form.deliver} onChange={handleChange} style={{ border:`solid ${formError && form.deliver === '' ? '2px' : '1px'} ${formError && form.deliver === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.deliver === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='deliver' type='text' placeholder='Deliver'/> */}
    </label>
    <label className='relative flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>Size</p>
    <div onClick={() => setSizeDrop(!sizeDrop)} className='flex select-none justify-between items-center cursor-pointer h-full border-2 p-2 border-purple-700 rounded-lg '>
      <Sort className='text-purple-700'/>
      <p className='text-purple-700  text-center font-semibold' >{currentSize}</p>
      <ArrowDropDown className='text-purple-700'/>
    </div>
    {sizeDrop && <div className='absolute rounded-lg md:w-auto w-full bg-white top-[110px] space-y-3 p-2 flex flex-col shadow-md shadow-purple-400'>
      <p onClick={() => setSize('30 - 35')} className='text-purple-700 select-none text-center p-2 cursor-pointer rounded-[5px] hover:bg-purple-200 font-semibold'>Sizes: 30 - 35</p>
      <p onClick={() => setSize('40 - 45')} className='text-purple-700 select-none text-center p-2 cursor-pointer rounded-[5px] hover:bg-purple-200 font-semibold'>Sizes: 40 - 45</p>
      <p onClick={() => setSize('45 - 46')} className='text-purple-700 select-none text-center p-2 cursor-pointer rounded-[5px] hover:bg-purple-200 font-semibold'>Sizes: 45 - 46</p>
    </div>}
    {/* <input value={form.condition} onChange={handleChange} style={{ border:`solid ${formError && form.condition === '' ? '2px' : '1px'} ${formError && form.condition === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.condition === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='condition' type='text' placeholder='Condition'/> */}
    </label>
    <label className='flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>Material</p>
    <input value={form.material} onChange={handleChange} style={{ border:`solid ${formError && form.material === '' ? '2px' : '1px'} ${formError && form.material === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.material === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='material' type='text' placeholder='Material'/>
    </label>
    <label className='flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>In Stock</p>
    <input value={form.stock} onChange={handleChange} style={{ border:`solid ${formError && form.stock === '' ? '2px' : '1px'} ${formError && form.stock === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.stock === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='stock' type='text' placeholder='Stock'/>
    </label>
    </div>
    <label className='flex flex-col p-2 '>
    <p className='text-purple-700 font-semibold p-2'>Description</p>
    <textarea rows='6' value={form.description} onChange={handleChange} style={{ border:`solid ${formError && form.description === '' ? '2px' : '1px'} ${formError && form.description === '' ? 'red' : 'gray'}` }} required className={`focus:border-none ${formError && form.description === '' ? 'bg-red-100' : ''} w-full p-2 rounded-lg`} name='description' type='text' placeholder='Describe your product'/>
    </label>
    <div className='flex flex-col p-2 bg-violet-100 rounded-lg'>
    <p className='text-purple-700 font-semibold p-2'>Upload pictures</p>
    <div className='flex flex-wrap p-4 justify-between items-center'>
      <input hidden id='img1' type='file' accept='image/*' onChange={(e) => handleFileChange(e, 'img1')}/>
      {
      preview1 ? 
      <img className='m-2 rounded-lg w-[100px] h-[100px]' src={preview1} alt='Image 1'/>
      :
      <label htmlFor='img1'>
        <Photo style={{ fontSize:'100px' }} className='cursor-pointer text-violet-400'/>
      </label>}
      
      
      <input hidden id='img2' type='file' accept='image/*' onChange={(e) => handleFileChange(e, 'img2')}/>
      {
      preview2 ? 
      <img className='m-2 rounded-lg w-[100px] h-[100px]' src={preview2} alt='Image 2'/>
      :
      <label htmlFor='img2'>
        <Photo style={{ fontSize:'100px' }} className='cursor-pointer text-violet-400'/>
      </label>}


      <input hidden id='img3' type='file' accept='image/*' onChange={(e) => handleFileChange(e, 'img3')}/>
      {
      preview3 ? 
      <img className='m-2 rounded-lg w-[100px] h-[100px]' src={preview3} alt='Image 3'/>
      :
      <label htmlFor='img3'>
        <Photo style={{ fontSize:'100px' }} className='cursor-pointer text-violet-400'/>
      </label>}


      <input hidden id='img4' type='file' accept='image/*' onChange={(e) => handleFileChange(e, 'img4')}/>
      {
      preview4 ? 
      <img className='m-2 rounded-lg w-[100px] h-[100px]' src={preview4} alt='Image 4'/>
      :
      <label htmlFor='img4'>
        <Photo style={{ fontSize:'100px' }} className='cursor-pointer text-violet-400'/>
      </label>}
    </div>
    </div>
  <p onClick={()=> setFormPreview(true)} className='font-bold w-auto text-center bg-violet-700 rounded-lg cursor-pointer shadow-md mt-6 text-white px-4 py-2'>Continue</p> 
  </form>
  :
  <div className='  md:w-[50vw] bg-white flex flex-col p-2 space-y-2'>
    <p className='text-2xl font-semibold text-violet-700 text-center'>Preview</p>
    <div className='flex flex-col md:flex-row md:space-x-4 items-center w-full'>
        <div>
          {/* <Photo style={{ fontSize:'300px' }} className='text-violet-400'/> */}
          <img className='p-2 rounded-lg w-[45rem] h-[20rem]' src={preview1} alt='Image 1'/>
          
        <button className='hidden md:flex bg-violet-700 m-2 text-white rounded-[5px] p-2 cursor-pointer font-semibold text-center w-auto'>Post</button>
        </div>
        <div className='flex flex-col space-y-3 p-4'>
        <p className='font-bold text-gray-500'>
          
        <span className='text-violet-700'>Name:</span> Dr Martenes Loafers
        </p>
        <p className='font-bold text-gray-500'>
        <span className='text-violet-700'>Price:</span> 55,000
        </p>
        <p className='font-bold text-gray-500'>
        <span className='text-violet-700'>Size:</span> 40 - 46
        </p>
        <p className='font-bold text-gray-500'>
        <span className='text-violet-700'>Description:</span> Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tempora voluptatem molestiae itaque aliquid quod.
        </p>
        
        </div>
    </div>
        <p className='md:hidden flex bg-violet-700 m-2 text-white rounded-[5px] p-2 cursor-pointer font-semibold text-center '>Post</p>
  </div>  
}
  
  </div>
  )
}

export default ProductForm